// ─── ₪, drawn ────────────────────────────────────────────────────────────────
// Archivo, the number font, has no ₪, so a typed one is drawn by whatever font
// the device falls back to · a different height on every phone. This one is
// two strokes: up, across and down on the left; down, across and up on the
// right. Its height is 0.72em, the digits' cap height in Archivo, so at the
// same font size it stands exactly as tall as a "$" (sprint 16, 2.1; sprint 17).
export default function ShekelSign({ title }) {
  return (
    <svg viewBox="0 0 10 10" aria-hidden={title ? undefined : true} role={title ? "img" : undefined}
      style={{ height: "0.72em", width: "0.72em", marginInlineEnd: "0.06em", verticalAlign: "baseline", overflow: "visible", flexShrink: 0 }}>
      {title && <title>{title}</title>}
      <path d="M1 10V1h5.2v5.6M9 0v9H3.8V3.4" fill="none" stroke="currentColor" strokeWidth="1.15" strokeLinecap="butt" strokeLinejoin="round"/>
    </svg>
  );
}

// Zero size, no ink, in the flow: a "₪" beside the drawn one, so the figure
// still copies and searches as "₪83,570".
export const HIDDEN_TEXT = { fontSize: 0, opacity: 0, whiteSpace: "nowrap" };
